import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CAMPAIGN_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.CAMPAIGN_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.CAMPAIGN_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.CAMPAIGN_BY_ID_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.CAMPAIGN_BY_ID_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
